import { render } from "./SessionDetailsModal.vue?vue&type=template&id=f24a5954&scoped=true"
import script from "./SessionDetailsModal.vue?vue&type=script&lang=js"
export * from "./SessionDetailsModal.vue?vue&type=script&lang=js"

import "./SessionDetailsModal.vue?vue&type=style&index=0&id=f24a5954&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f24a5954"]])

export default __exports__